// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"0cfe97ae","262":"47b7d927","722":"353001ae","985":"8bdf5000"}[chunkId] + ".chunk.js";
};